import React from 'react';
import PropTypes from 'prop-types';

const ScrollContainer = ({ children, height = '100%', style = {} }) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    height,
    ...style
  }}>
    <div style={{
      flex: 1,
      overflowY: 'auto',
      ...(style.overflow ? { overflow: style.overflow } : {})
    }}>
      {children}
    </div>
  </div>
);

ScrollContainer.propTypes = {
  children: PropTypes.node.isRequired,
  height: PropTypes.string,
  style: PropTypes.object
};

export default ScrollContainer;
